module.exports = __webpack_public_path__ + "d6dab72b268259156ac3e3e356d607f3.png";